import { Review } from 'bz-draft';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';

@inject('preview')
@observer
class Preview extends React.Component {
  render() {
    if (!this.show) return null;

    let { preview } = this.props;

    return (
      <div>
        <hr />
        <h4>Snippet Preview</h4>
        <div className="snippet-preview">
          <Review store={preview} />
        </div>
      </div>
    );
  }

  @computed
  get show() {
    return !this.props.preview.loading;
  }
}

export default Preview;
